import { render } from "./UnresolvedThread.vue?vue&type=template&id=722146e5"
import script from "./UnresolvedThread.vue?vue&type=script&lang=js"
export * from "./UnresolvedThread.vue?vue&type=script&lang=js"

import "./UnresolvedThread.vue?vue&type=style&index=0&id=722146e5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/UnresolvedThread.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "722146e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('722146e5', __exports__)) {
    api.reload('722146e5', __exports__)
  }
  
  module.hot.accept("./UnresolvedThread.vue?vue&type=template&id=722146e5", () => {
    api.rerender('722146e5', render)
  })

}


export default __exports__